export default {
  SO: 'Sud-Ouest',
  PCP: 'Paris Centre Picardie',
  SE: 'Sud-Est',
  NE: 'Nord-Est',
  O: 'Ouest',
  S: 'Siège'
}
